import { METRIC_TYPES } from "helpers/assets/constants"
import { createSelector } from "reselect"
import { getSelectedViewIsContentSet } from "selectors/contentSets"

export const getBaseMetricTypeOptions = createSelector(
  [getSelectedViewIsContentSet],
  (isContentSet) => ({
    exposure: [{
      id: METRIC_TYPES.NET_CONTRIBUTION,
      value: "Net Contribution",
      primaryText: "Net Contribution",
      secondaryText: "The position's net contribution to the portfolio.",
      isDefault: true,
    }, {
      id: METRIC_TYPES.CURRENCY_EXPOSURE,
      value: "Currency Exposure",
      primaryText: "Currency Exposure",
      ...(isContentSet ? {
        secondaryText: "Exposure in content set numeraire currency.",
      } : {
        secondaryText: "Exposure in risk model numeraire currency.",
      }),
    }, {
      id: METRIC_TYPES.Z_SCORE,
      ...(isContentSet
        ? { value: "Raw asset score", primaryText: "Raw asset score" }
        : { value: "Asset z-score", primaryText: "Asset z-score" }),
      ...(isContentSet ? {
        secondaryText: "Exposure scores per-security as provided by the content set.",
      } : {
        secondaryText: "Exposure z-scores per-security as provided by the risk model.",
      }),
    }],
    beta: [{
      id: METRIC_TYPES.NET_CONTRIBUTION,
      value: "Net Contribution",
      primaryText: "Net Contribution",
      secondaryText: "The position's net contribution to the portfolio.",
      isDefault: true,
    }, {
      id: METRIC_TYPES.STANDALONE,
      value: "Standalone",
      primaryText: "Standalone",
      secondaryText: "The position's beta without correlations to other assets of the portfolio.",
    }],
    risk: [{
      id: METRIC_TYPES.RISK_DECOMPOSITION,
      value: "Risk decomposition",
      primaryText: "Risk decomposition",
      secondaryText: "% risk contribution to total risk, as % variance.",
      isDefault: true,
    }],
    sensitivity: [{
      id: METRIC_TYPES.NET_CONTRIBUTION,
      value: "Net Contribution",
      primaryText: "Net Contribution",
      secondaryText: "The position's net contribution to the portfolio.",
      isDefault: true,
    }, {
      id: METRIC_TYPES.STANDALONE,
      value: "Standalone",
      primaryText: "Standalone",
      secondaryText: "Per-security factor sensitivity as calculated by factor volatility * security's factor exposure.",
    }],
    performance: [{
      id: METRIC_TYPES.NET_CONTRIBUTION,
      value: "Net Contribution",
      primaryText: "Net Contribution",
      secondaryText: "The position's net contribution to the portfolio.",
      isDefault: true,
    }, {
      id: METRIC_TYPES.CURRENCY_PERFORMANCE,
      value: "Currency Performance",
      primaryText: "Currency Performance",
      secondaryText: "Performance in numeraire currency.",
    }],
  }),
)
